import { useAiInsightsAdoption } from "./useAiInsightsAdoption";

export interface AiInsightsGate {
    /** Confirmed adopted. */
    adopted: boolean;
    /** Adoption state still loading. */
    loading: boolean;
    /**
     * Definitely locked — adoption resolved and the tool is not adopted.
     * `false` while loading so surfaces don't flash a locked state on first paint.
     */
    locked: boolean;
    /** Convenience inverse of `locked` (show/keep the surface). */
    available: boolean;
}

/**
 * Single source of truth for the AI Insights lock decision (issue #189).
 *
 * Wraps {@link useAiInsightsAdoption} and derives `locked`/`available` once, so
 * every gated surface stops re-deriving `!loading && !adopted` on its own.
 */
export const useAiInsightsGate = (): AiInsightsGate => {
    const { adopted, loading } = useAiInsightsAdoption();
    const locked = !loading && !adopted;
    return { adopted, loading, locked, available: !locked };
};
